const WL = [
    {id: "0", value: "盈轉虧"},    
    {id: "1", value: "虧轉盈"}
  ];  
  
  export default WL